import { render, staticRenderFns } from "./CommonAttr.vue?vue&type=template&id=ccf4e1d0"
import script from "./CommonAttr.vue?vue&type=script&lang=js"
export * from "./CommonAttr.vue?vue&type=script&lang=js"
import style0 from "./CommonAttr.vue?vue&type=style&index=0&id=ccf4e1d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports